import React, { useContext, useEffect, useState } from "react";
import LayoutNew from "../components/shared/LayoutNew";
import { Form, Button, InputGroup, ButtonGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate} from "react-router-dom";
import { apiGet, apiPost } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { toast } from "react-toastify";
import moment from "moment";
import { useTranslation } from "react-i18next";
import AuthContext from "../context/AuthContext";
import promotioBg from "../assets/images/promotion-bg.svg";
import iconClock from "../assets/images/icon-clock.svg";



const Promotions = () => {
    const {profileData,user} = useContext(AuthContext);
    const [data, setData] = useState([]);
  const navigate = useNavigate();

 const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional);
    if (status == 200) {
      if (data?.success) {
        let updated = getFilteredOfferList(
          profileData?.userDepositCount || 0,
          data?.results?.offerList,
        );
        setData(updated);
      }
    }
  };
  useEffect(() => {
    getData();
  }, [profileData]);
  function getTimeDifferenceString(currentTime, endTime) {
    const now = moment(currentTime);
    const end = moment(endTime);

    if (end.isBefore(now)) {
      return "Ended";
    }

    const duration = moment.duration(end.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    return `End in ${days} days ${hours} hours`;
  }
  return (
    <LayoutNew>
       <div class="top-class">
        {data?.length > 0 &&
          data?.map((res) => {
            return (
              <div class="promotion-box new promotion-toggle ">
                <div class="pic ">
                  <img
                    class=""
                    alt="image_90025"
                    src={`${process.env.REACT_APP_API_BASE_URL}${res?.offerImage}`}
                    loading="lazy"
                  />
                  <span class="item-bg ">
                    <img
                      class=""
                      alt="image_90025"
                      src={promotioBg}
                      loading="lazy"
                    />
                  </span>
                </div>
                <div class="promotion-box-inner content-style ">
                  <div class="text-main ">
                    <h3 class="">{res?.title}</h3>
                    <p class="">{res?.description}</p>
                  </div>
                  <div class="times ">
                    <span class="item-icon me-2">
                      <img alt="image_90025" src={iconClock} loading="lazy" />
                    </span>
                    <span class="">
                      {moment(res?.offerStartDateTime).format(
                        "YYYY/MM/DD HH:MM:SS",
                      )}{" "}
                      -{" "}
                      {moment(res?.offerEndDateTime).format(
                        "YYYY/MM/DD HH:MM:SS",
                      )}
                    </span>
                  </div>
                  <div
                    onClick={() =>
                      navigate(
                        isEmpty(user) ? "/register" : `/deposit/${res?._id}`,
                      )
                    }
                    class="button-box "
                  >
                    <div mcdneuaclick="" class="button btn-primary ">
                      <span class="">
                        {" "}
                        {isEmpty(user) ? "Join Now" : "Deposit"}{" "}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}{" "}
      </div>
    </LayoutNew>
  );
};

export default Promotions;
